<template>
  <div class="itens_caroussel" id="banner">
    <carousel
      :perPage="1"
      :autoplay="true"
      :paginationEnabled="false"
      :loop="true"
      :autoplayTimeout="8000"
      :mouseDrag="false"
      :space-padding="0"
    >
      <slide v-for="(banner, index) in banners" :key="index">
        <img
          :src="require(`@/assets/${banner.image}`)"
          :alt="banner.name"
          loading="lazy"
        />
      </slide>
    </carousel>
  </div>
</template>

<script>
import store from "@/storeData.js";
import { Carousel, Slide } from "vue-carousel";

export default {
  data() {
    return {
      banners: store.banners
    };
  },
  components: {
    Carousel,
    Slide
  }
};
</script>
